import { forwardRef } from 'react';

import { IconProps } from '.';

export const ClockIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M10 6.98999C10 6.57578 9.66421 6.23999 9.25 6.23999C8.83579 6.23999 8.5 6.57578 8.5 6.98999V10.74L8.50002 10.745L8.5 10.75C8.5 11.1642 8.83579 11.5 9.25 11.5H13C13.4142 11.5 13.75 11.1642 13.75 10.75C13.75 10.3358 13.4142 10 13 10H10V6.98999Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 17.5C8.51664 17.5 7.06659 17.0601 5.83322 16.236C4.59985 15.4119 3.63856 14.2406 3.0709 12.8701C2.50325 11.4997 2.35472 9.99168 2.64411 8.53683C2.9335 7.08197 3.6478 5.7456 4.6967 4.6967C5.74559 3.64781 7.08196 2.9335 8.53682 2.64411C9.99168 2.35472 11.4997 2.50325 12.8701 3.07091C14.2406 3.63856 15.4119 4.59986 16.236 5.83323C17.0601 7.0666 17.5 8.51664 17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5ZM10 4C8.81331 4 7.65327 4.3519 6.66658 5.01119C5.67988 5.67047 4.91085 6.60755 4.45672 7.7039C4.0026 8.80026 3.88378 10.0067 4.11529 11.1705C4.3468 12.3344 4.91824 13.4035 5.75736 14.2426C6.59647 15.0818 7.66557 15.6532 8.82946 15.8847C9.99334 16.1162 11.1997 15.9974 12.2961 15.5433C13.3925 15.0892 14.3295 14.3201 14.9888 13.3334C15.6481 12.3467 16 11.1867 16 10C16 8.4087 15.3679 6.88258 14.2426 5.75736C13.1174 4.63214 11.5913 4 10 4Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ClockIcon;
